import { MatSort } from '@angular/material/sort';
import {  RepoContact } from 'src/app/models/repo-business/repo-business.model';
import { MatDataSource } from '../../shared-new/util/mat-datasource';

export class RepoContactListDataSource extends MatDataSource<RepoContact> {
  public constructor(data: RepoContact[], sort: MatSort, disableInfiniteScroll: boolean = false,
    scrollLevel: number = 20) {
    super(data, sort, disableInfiniteScroll, scrollLevel);
    this.setFilterPredicate();
  }


  setFilterPredicate(): void {
    this.filterPredicate = (contact: RepoContact, filterValue: string = '') => {
      const search = filterValue.trim().toLowerCase();
      const regex = new RegExp(search, 'gi');

      return (
        // check simple string fields
        ['salutation', 'firstName', 'lastName', 'suffix', 'email', 'mobile', 'countryCode', 'phone']
          .some((key) => {
            const value = contact[key as keyof RepoContact];
            return value && regex.test(String(value).toLowerCase());
          })
        ||
        // check nested position
        (contact.position?.positionName &&
          regex.test(contact.position.positionName.toLowerCase()))
        ||
        // check nested business/org
        (contact.repoBusiness?.businessName &&
          regex.test(contact.repoBusiness.businessName.toLowerCase()))
      );
    };
  }

}
